import GradeAssignment from './GradeAssignment';

export default GradeAssignment;
